<script setup lang="ts">

import Up from "@icons/IcBaselineKeyboardArrowUp.svg"
import Down from "@icons/IcBaselineKeyboardArrowDown.svg"
import Left from "@icons/IcBaselineKeyboardArrowLeft.svg"
import Right from "@icons/IcBaselineKeyboardArrowRight.svg"
import { computed } from "vue";

const props = defineProps<{
	direction: 'up' | 'down' | 'left' | 'right';
}>();

const component = computed(() => {
	switch (props.direction) {
		case 'up':
			return Up;
		case 'down':
			return Down;
		case 'left':
			return Left;
		case 'right':
			return Right;
	}
});

</script>

<template>
	<component :is="component" class="arrow-icon" />
</template>

<style>
.arrow-icon {
	width: 16px;
	height: 16px;
	margin: -4px;
	flex: 0 0 auto;

	.sidebar &,
	.propeditor & {
		opacity: .3;
	}
}
</style>